import React from 'react';
import { Activity, Plus } from 'lucide-react';
import UnifiedActivityFeed from '../components/dashboard/UnifiedActivityFeed';
import ToDoSection from '../components/ToDoSection';

const ActivityPage = () => {
  return (
    <div className="p-6 bg-white dark:bg-black min-h-screen">
      {/* Beautiful Header like Eigentümer/Objekte-Seite */}
      <div className="mb-8">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white flex items-center gap-3">
              <Activity className="w-8 h-8 text-green-600" />
              Aufgaben & Aktivitäten
            </h1>
            <p className="text-gray-600 dark:text-gray-400 mt-2">
              Verwalten Sie Ihre Aufgaben und verfolgen Sie alle Aktivitäten
            </p>
          </div>
          <button className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg flex items-center gap-2 transition-colors">
            <Plus className="w-5 h-5" />
            Neue Aufgabe
          </button>
        </div>
      </div>
      
      {/* To-Do Section - OBERHALB der Activities */}
      <div className="mb-6">
        <ToDoSection />
      </div>
      
      {/* Activities Section - Mit konsistenter Abrundung und Hybrid-Styling */}
      <div className="bg-white dark:bg-slate-900 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700">
        <div className="p-6 border-b border-gray-200 dark:border-gray-700">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Activity Log</h2>
          <p className="text-gray-600 dark:text-gray-400 mt-1">Chronologische Übersicht aller Systemaktivitäten</p>
        </div>
        <UnifiedActivityFeed 
          mode="full"
          showFilter={true}
          autoRefresh={true}
          refreshInterval={30}
        />
      </div>
    </div>
  );
};

export default ActivityPage;

